import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const EpisodesPage = lazy(() => import('../pages/episodes/page'));
const EpisodeDetailPage = lazy(() => import('../pages/episodes/detail/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ResourceDetailPage = lazy(() => import('../pages/resources/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const ArticleDetailPage = lazy(() => import('../pages/articles/detail/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminEpisodesPage = lazy(() => import('../pages/admin/episodes/page'));
const AdminResourcesPage = lazy(() => import('../pages/admin/resources/page'));
const AdminArticlesPage = lazy(() => import('../pages/admin/articles/page'));
const AdminContentPage = lazy(() => import('../pages/admin/content/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/at-the-mic',
    element: <EpisodesPage />,
  },
  {
    path: '/at-the-mic/:id',
    element: <EpisodeDetailPage />,
  },
  {
    path: '/receipts',
    element: <ResourcesPage />,
  },
  {
    path: '/receipts/:id',
    element: <ResourceDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/articles',
    element: <ArticlesPage />,
  },
  {
    path: '/articles/:id',
    element: <ArticleDetailPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/episodes',
    element: <AdminEpisodesPage />,
  },
  {
    path: '/admin/resources',
    element: <AdminResourcesPage />,
  },
  {
    path: '/admin/articles',
    element: <AdminArticlesPage />,
  },
  {
    path: '/admin/content',
    element: <AdminContentPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;